import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import { Header, Footer, Stockists, SignupForm, Competition } from '../components'
import { ParallaxProvider } from 'react-scroll-parallax';

import { media, width } from '../styles/utils'

import '../styles/global'
import '../styles/fonts'

const Layout = ({ children, data, location }) => (

	<SiteWrapper>
	
    	<Helmet
			title={data.site.siteMetadata.title}
			meta={[
				{ name: 'description', content: data.wordpressOptions.meta_description_default},
                 { name: 'keywords', content: data.site.siteMetadata.keywords },
                { property: 'og:url', content: data.site.siteMetadata.url },
                //{ property: 'og:image', content: ogProfileImage },
                { property: 'og:title', content: data.site.siteMetadata.title },
                { property: 'og:description', content: data.wordpressOptions.meta_description_default },
                { property: 'twitter:card', content: 'summary' }, 
                { property: 'twitter:title', content: data.site.siteMetadata.title },
                { property: 'twitter:description', content: data.wordpressOptions.meta_description_default}
            ]}
		/>

        <Helmet>
            <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
        </Helmet>

        <Header
            location={location}
            contactData={data.wordpressContact}
        />

        <ParallaxProvider>
            {children()}     
        </ParallaxProvider>


        {/* {data.wordpressLanding && (
            <Splash
                location={location}
                data={data.wordpressLanding}
            />
        )} */}

        <SignupForm/>

        <Competition
            data={data.wordpressOptions}
        />

        <Footer
            data={data.wordpressOptions}
        />

  </SiteWrapper>
)

const SiteWrapper = styled.div`
    height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
    max-width: 100vw;
    overflow-x: hidden;

    /* Preserve height for header */

    padding-top: 140px;

    ${media.phone`
        padding-top: 78px;
    `}

    /* Transition wrapper */

    > *:not(:first-child) { 
        width: 100%;
        will-change: opacity;
        /* transform: translate3d(0,0,0) */
    }

    > *:nth-child(2) {
        background: white;
        margin-bottom: 350px;
        border-bottom: 2px solid black;
        box-sizing: border-box;

        ${media.phone`
            margin-bottom: 576px;
        `}
    }
`

export default Layout


export const query = graphql`
	query Index {
		site {
			siteMetadata {
                title,
                description,
                keywords,
                url
			}
        }
        
        wordpressOptions {
            copyright
            quote_slider{
                ... on quoteSlider_2 {
                    text
                    credit
                }
            }
            mc_signup_image
            mc_signup_text
            meta_description_default
        }
        
        wordpressContact {
            acf {
                contact_details {
                    subtitle
                    email
                }
            }
        }
        
        wordpressLanding {
            acf {
                slideshow {
                    ... on slideshow_6{
                        media_type
                        video_url 
                        image {
                            sizes {
                                fullwidth
                            }
                        }
                    }
                }
            }
        }

    }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js